import { useMemo, useRef, useState } from 'react';
import { detectHeadingSelection, disableTextHeadingDropdown } from '../../util/notes';
import { HEADING_LEVEL_MAP, HeadingFormatOptionLabel, headingFormatOptions, } from '../../types/notes/text_heading_dropdown';
const getDefaultHeadingFormatOption = headingFormatOptions.find(option => option.label === HeadingFormatOptionLabel.NORMAL);
const getMatchingHeadingFormatOptionsTypeByLevel = (level) => {
    return headingFormatOptions.find(option => option.label === HEADING_LEVEL_MAP[level]);
};
export const useInitializeTextHeadingDropdownContext = () => {
    const [disableTextHeadingDropdownYn, setDisableTextHeadingDropdownYn] = useState(false);
    const [activeHeadingOption, setActiveHeadingOption] = useState(getDefaultHeadingFormatOption);
    const getActiveHeadingOption = useRef((ctx, selection) => {
        const detectedHeadingLevel = detectHeadingSelection(ctx, selection);
        if (disableTextHeadingDropdown(ctx, selection)) {
            setDisableTextHeadingDropdownYn(true);
        }
        else {
            setDisableTextHeadingDropdownYn(false);
        }
        const selectedOption = getMatchingHeadingFormatOptionsTypeByLevel(detectedHeadingLevel);
        setActiveHeadingOption(selectedOption);
    });
    const selectActiveHeadingOption = useRef((selectedOption) => {
        setActiveHeadingOption(selectedOption);
    });
    return useMemo(() => {
        return {
            selectionForHeading: getActiveHeadingOption.current,
            disableTextHeadingDropdownYn,
            activeHeadingOption,
            selectActiveHeadingOption: selectActiveHeadingOption.current,
        };
    }, [disableTextHeadingDropdownYn, activeHeadingOption]);
};
//# sourceMappingURL=use_initialize_text_heading_dropdown_context.js.map